module.exports = __webpack_public_path__ + "pc/img/swiper_bg_02.346cca5e.png";